const API_KEY = "AIzaSyAWHqWLZ3plMXNU4lYlcvO56w1FqPxIKDU";
const CLIENT_ID =
  "295869428599-gdhvgls4aai9307j2vp7qakq324rgpsj.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/contacts.readonly";
const CLIENT_SECERT = "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";
// const REDIRECT_URI = "http://localhost:3000"; //to check in localhost
const REDIRECT_URI = "https://mtngc.magiccallapp.info";

export { API_KEY, SCOPES, CLIENT_ID, CLIENT_SECERT, REDIRECT_URI };
